"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemRadioGroup = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/menu-item/menu-item-group");
require("@/components/common/menu-item/semantics/menu-item-radio");
const single_selection_controller_1 = require("@/controllers/single-selection-controller");
const slotted_selection_controller_1 = require("@/controllers/slotted-selection-controller");
const utils_1 = require("@/utils");
let MenuItemRadioGroup = class MenuItemRadioGroup extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.name = '';
        this.value = '';
        this.size = 'medium';
        this.ariaLabel = '';
        this.selection = new single_selection_controller_1.SingleSelectionController({
            getValue: () => this.value,
            setValue: value => {
                this.value = value;
            },
        });
        this.group = new slotted_selection_controller_1.SlottedSelectionController(this, {
            selection: this.selection,
            getItems: () => this.radios,
            applyItem: radio => {
                if (this.name)
                    radio.name = this.name;
            },
            onChange: () => {
                (0, utils_1.emit)(this, 'change', { value: this.value, name: this.name });
            },
        });
    }
    render() {
        return (0, lit_1.html) `
      <mm-menu-item-group
        role="radiogroup"
        size=${this.size}
        aria-label=${this.ariaLabel || lit_1.nothing}
        @change=${this.group.handleItemChange}
      >
        <slot @slotchange=${this.group.handleSlotChange}></slot>
      </mm-menu-item-group>
    `;
    }
};
MenuItemRadioGroup.styles = (0, lit_1.css) `
    :host {
      display: block;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], MenuItemRadioGroup.prototype, "name", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], MenuItemRadioGroup.prototype, "value", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], MenuItemRadioGroup.prototype, "size", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-label' })
], MenuItemRadioGroup.prototype, "ariaLabel", void 0);
__decorate([
    (0, decorators_js_1.queryAssignedElements)({ selector: 'mm-menu-item-radio' })
], MenuItemRadioGroup.prototype, "radios", void 0);
MenuItemRadioGroup = __decorate([
    (0, decorators_js_1.customElement)('mm-menu-item-radio-group')
], MenuItemRadioGroup);
exports.MenuItemRadioGroup = MenuItemRadioGroup;
//# sourceMappingURL=data:application/json;base64,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